import {ID, Response} from '../../../../../../_metronic/helpers'
import {FieldProps} from '../../../../../../_component/Form'

export type Job = {
  id?: ID
  title?: string
  slug?: string
  department?: string
  location?: string
  type?: string
  content?: string
  status?: boolean
  additionalFields?: any[]
  AdditionalFields?: any[]
  Applications?: any[]
}

export type JobsQueryResponse = Response<Array<Job>>

export const fields: FieldProps[] = [
  {name: 'title', label: 'Title', required: true, table: true, sortable: true, full: false},
  {name: 'slug', label: 'Slug', required: false, table: false, sortable: false, full: false, create: false},
  {name: 'department', label: 'Department', required: true, table: true, sortable: true, full: false},
  {name: 'location', label: 'Location', required: true, table: true, sortable: true, full: false},
  {
    name: 'type',
    label: 'Job Type',
    type: 'select',
    required: true,
    table: true,
    sortable: true,
    full: false,
    options: [
      {label: 'Full Time', value: 'FULL_TIME'},
      {label: 'Part Time', value: 'PART_TIME'},
      {label: 'Contract', value: 'CONTRACT'},
      {label: 'Remote', value: 'REMOTE'},
    ],
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    required: true,
    table: true,
    sortable: true,
    full: false,
    options: [
      {label: 'Draft', value: 'DRAFT'},
      {label: 'Published', value: 'PUBLISHED'},
      {label: 'Closed', value: 'CLOSED'},
    ],
  },
  {name: 'content', label: 'Job Content', table: false, type: 'content', full: true, required: true},
  {name: 'additional_fields', label: 'Custom Application Questions', type: 'additional-fields' as any, table: false, full: true, required: false, view: false, initialValue: []},
]
